import { Box, Button, IconButton, Tooltip, Typography, Chip, Stack, } from "@mui/material";
import Table, { ColumnType } from "components/Table";
import useTitle from "hooks/useTitle";
import { useEffect, useState } from "react";
import { useMutation, useQuery } from "react-query";
import { ResType } from "types";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { resetFilters } from "redux/reducers/taskboardSlice";
import { Visibility } from "@mui/icons-material";
import {
  exportClientproceedingFyi,
  getClientproceedingFyi,
  getExcelFyiSections,
} from "api/services/automation/income-tax";
import AccessDenied from "./Access/accessDenide";
import Loader from "components/Loader";
import { resetState } from "redux/reducers/clientsSlice";
import { getCurrentFormattedDateTime } from "utils";
import { snack } from "components/toast";
import { handleError } from "utils/handleError";
import SearchContainer from "components/SearchContainer";
import { dropDownType, getAutFinancialYears } from "pages/atom-pro/constants";
import FilterEngine from "pages/atom-pro/Filters";
import { buildChips } from "pages/atom-pro/Filters/buildChips";
import excelIcon from "./../../assets/images/128px-Microsoft_Office_Excel_(2019–2025).svg.png";
import clearFilters from "./../../assets/images/clear-filter.svg";
import { hasActiveFilters } from "pages/atom-pro/Filters/components";
import { StyledSpan } from "./styles";
import moment from "moment";



const ClientEproceedingFyi = (state) => {
  useTitle("ATOM Pro | Clients");
  const [page, setPage] = useState<number>(0);
  const [pageCount, setPageCount] = useState<number>(10);
  const [totalCount, setTotalCount] = useState<number>(0);
  const dispatch = useDispatch();
  const params = useParams();
  const [sections, setSectionData] = useState<any>(null);
  const [search, setSearch] = useState("");

  const [filters, setFilters] = useState({
    section: null,
    assessmentYear: null,
    type: null
  })

  useEffect(() => {
    return () => {
      dispatch(resetFilters());
      dispatch(resetState());
    };
  }, []);
  const [checkAccess, setCheckAccess] = useState(true);
  const { data, isLoading }: ResType = useQuery(
    [
      "client-proceedingfyi",
      params.incometaxid,
      {
        limit: pageCount,
        offset: page * pageCount,
        search: search,
        ...filters
      },
    ],
    getClientproceedingFyi,
    {
      onSuccess: (res) => {
        setTotalCount(res?.data?.count);
        setCheckAccess(res?.data?.accessDenied);
      },
    }
  );


  const handleSearch = (e) => {
    setSearch(e);
    setPage(0);
  };

  const { data: sectionData, isLoading: sectionIsloading }: ResType = useQuery(
    ["excel-e-proceedings-sections"],
    getExcelFyiSections,
    {
      onSuccess: (res) => {
        setSectionData(res?.data);
      },
    }
  );
  const { mutate: mutate1, isLoading: isExporting } = useMutation(exportClientproceedingFyi, {
    onSuccess: (res: any) => {
      let clientName = res.data?.profileDetails?.name
      const arr = new Uint8Array(res.data?.buffer?.data);
      const blob = new Blob([arr], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const file = window.URL.createObjectURL(blob);
      let link = document.createElement("a");
      const formattedDateTime = getCurrentFormattedDateTime();
      link.href = file;
      link.download = `ATOM Pro - ${clientName} Income Tax (PAN) e-Proceedings (For Your Information) ${formattedDateTime}.xlsx`;
      link.click();
      snack.success("Income Tax (PAN) e-proceedings exported sucessfully");
    },
    onError: (err: any) => {
      snack.error(err);
      snack.error(handleError(err));
    },
  });

  const handleExport = () => {
    if (isExporting) return;
    mutate1({
      incometaxid: params.incometaxid,
      ...state,
    });
  };

  const filterConfig = {
    assessmentYear: {
      label: "Assessment Year",
      type: "year",
      options: getAutFinancialYears(),
      getValue: (year) => year.split("-")[0],
    },
    section: {
      label: "Section",
      type: dropDownType.array,
      options: sections,
    },
    type: {
      label: "Type",
      type: dropDownType.array,
      options: ["Self", "Other"],
    },
  };

  const chips: any = buildChips(filters, filterConfig);
  
  const isFilterActive = hasActiveFilters(filters);


  if (isLoading) return <Loader />;
  return (
    <>
      <Box m={1}>
        {!checkAccess && <AccessDenied />}

        {checkAccess && (
          <>
            <Box mb={1} display="flex" alignContent="center" justifyContent='space-between'>
              <SearchContainer
                debounced
                value={search}
                placeHolder="Search by Proceeding Name"
                onChange={handleSearch}
              />
              <Box>

                <FilterEngine filters={filters} config={filterConfig} setFilters={setFilters} setPage={setPage} />
              {isFilterActive && (
                <Tooltip title={'Reset Filters'}>
                  <img
                    src={clearFilters}
                    alt="Export"
                    style={{ cursor: 'pointer', width: 38, height: 38, marginRight: "5px", marginLeft: "5px" }}
                    onClick={() => {

                    setSearch("");
                    setFilters({
                      section: null,
                      assessmentYear: null,
                      type: null
                    })
                  }}
                />
              </Tooltip>
              )}
                <Button>
                  <Tooltip title={isExporting ? "Exporting..." : "Data Export to Excel"}>
                    <img
                      src={excelIcon}
                      alt="Export"
                      style={{
                        cursor: isExporting ? "not-allowed" : "pointer",
                        width: 30,
                        height: 30, marginTop: -10,
                        opacity: isExporting ? 0.5 : 1,
                        transition: "opacity 0.2s ease",
                      }}
                      onClick={handleExport}
                    />
                  </Tooltip>
                </Button>

              </Box>
            </Box>
            <Box>
              <Stack direction="row" spacing={1} sx={{ mb: 1, ml: 2, mt: 1, flexWrap: "wrap" }}>
                {chips.map((chip) => (
                  <Chip
                    key={chip.key}
                    label={chip.label}
                    onDelete={() => {
                      const updated = { ...filters, [chip.key]: "" };
                      setFilters(updated);
                    }}
                    variant="outlined"
                    color="primary"
                  />
                ))}
              </Stack>




              {/* <Button variant="outlined" color="secondary" onClick={handleExport}
                                          startIcon={<FileDownloadOutlinedIcon />}
                                          sx={{ marginLeft: 2 }}
                                        >
                                          Export
                                        </Button> */}
              <Box>{/* <ClientsHeader search={search} setSearch={setSearch} /> */}</Box>
            </Box>
            <Table
              sx={{ pb: 0, mb: 0, height: "440px" }}
              pagination={{ totalCount, pageCount, setPageCount, page, setPage }}
              data={data?.data?.result || []}
              columns={columns}
              loading={isLoading}
            />
          </>
        )}
      </Box>
    </>
  );
};

const generateAssessmentYear = (assessmentYear) => {
  if (!assessmentYear || assessmentYear === "0" || assessmentYear === "") {
    return "NA";
  } else if (!isNaN(assessmentYear) && assessmentYear.length === 4) {
    const year = parseInt(assessmentYear);
    const nextYear = (year + 1).toString().slice(-2);
    return `AY ${year}-${nextYear}`;
  } else {
    return assessmentYear;
  }
};

const columns: Array<ColumnType> = [
  {
    key: "assessmentYear",
    title: "Assessment Year",
    render: (v) => <Typography>{generateAssessmentYear(v?.assessmentYear)}</Typography>,
  },
  { key: "type", title: "Type" },
  {
    key: "noticeName",
    title: (
      <Box display="flex" alignItems="center">
        Section
      </Box>
    ),
    render: (v) => <Typography>{v?.noticeName ? <span>{v.noticeName}</span> : "--"}</Typography>,
  },
  {
    key: "sectionCodeText",
    title: "Proceeding Name",
    render: (v) => <Typography>{v.proceedingName}</Typography>,
  },
  {
    key: "",
    title: (
      <Box display="flex" alignItems="center">
        Assessee Name (PAN)
      </Box>
    ),
    render: (v) => {
      const displayName = (v?.type === "Other" && v?.notices[0]?.nameOfAssesse) ? v?.notices[0]?.nameOfAssesse : "--";
      return <Typography>{displayName} {v?.type === "Other" && (<span>{'(' + v?.pan + ')'}</span>)}</Typography>;
    },
  },

  {
    key: "proceedingClosureDate",
    title: "Proceeding Closed On",
    render: (v) => <Typography>{v?.proceedingClosureDate ? " " + moment(Number(v?.proceedingClosureDate)).format("DD-MM-YYYY HH:mm") : "-"}</Typography>,
  },

  {
    key: "",
    title: "Actions",
    render: (rowData: any) => <Actions data={rowData} />,
  },
  {
    key: "id",
    title: "Created Type",
    render: (v) =>
      <Box>
        {v?.createdType === "MANUAL" ? (
          <StyledSpan bgColor="#f2e6ff">Manual</StyledSpan>
        ) : (
          <StyledSpan bgColor="#b3ecff">Portal</StyledSpan>
        )}
      </Box>
  },
];

function Actions(props: any) {
  const navigate = useNavigate();

  const handleViewMoreClick = () => {
    navigate(`/atom-pro/income-tax/proceeding-information/${props.data?.id}`);
  };

  return (
    <IconButton onClick={handleViewMoreClick} size="small">
      <Visibility />
    </IconButton>
  );
}

export default ClientEproceedingFyi;
